import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";

@Component({
  standalone: true,
  selector: "app-prefix-img",
  imports: [],
  templateUrl: "./prefix-img.component.html",
  styleUrl: "./prefix-img.component.less",
})
export class PrefixImgComponent extends PrefixComponent<string> {
  public hiddenWhenUnresolved: boolean;

  public constructor() {
    super();
    this.post = false;
    this.hiddenWhenUnresolved = false;
    this.characters = ALLOWED_CHARACTERS["img"];
  }
}
